import Vue from 'vue';
import organizationMemberTransformer from './../../transformers/organizationMember';
import store from './../../store';

const success = (data, resolve) => {
  store.dispatch('addOrganizationMember', organizationMemberTransformer.fetch(data));
  resolve(data);
};

const failed = (errors, reject) => {
  reject(organizationMemberTransformer.fetch(errors));
};

export default organizationMember => (
  new Promise((resolve, reject) => {
    Vue.$http
      .post('/organization_members', organizationMemberTransformer.send(organizationMember))
      .then((response) => {
        success(response.data, resolve);
      })
      .catch((error) => {
        failed(error.response.data, reject);
      });
  })
);



// WEBPACK FOOTER //
// ./src/app/services/organizationMember/store.js